/**
 * The `admin-invite-user` request the v2 Create Tenant form sends.
 *
 * Pulled out of the page for one reason: `preserve_existing_role`. The email
 * typed into that form is not always new. An owner who also rents a room is a
 * real case — it is exactly what the COL-447 sales-demo account is — and for
 * an email that already belongs to someone, `admin-invite-user` reads
 * `role: "user"` as a DEMOTION: it deletes every elevated role the account
 * holds (`owner` among them) and, because the incoming role isn't `owner`,
 * deletes all of their `property_owners` rows as well.
 *
 * Creating a booking must never cost an account its ownership, so the flag is
 * always on here, and it is asserted in `create-tenant-invite.test.ts` so a
 * later edit to the form cannot quietly drop it again.
 */
export type CreateTenantInviteInput = {
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
};

export type CreateTenantInviteBody = {
  email: string;
  name: string;
  role: "user";
  skip_invite_email: true;
  phone: string | undefined;
  preserve_existing_role: true;
};

export function buildCreateTenantInviteBody(
  input: CreateTenantInviteInput
): CreateTenantInviteBody {
  return {
    email: input.email.trim().toLowerCase(),
    name: `${input.firstName.trim()} ${input.lastName.trim()}`,
    role: "user",
    // The admin sends the login link separately once the tenant is ready.
    skip_invite_email: true,
    phone: input.phone.trim() || undefined,
    // See the module comment — never flip this to false.
    preserve_existing_role: true,
  };
}
